/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getConnectedUser } from '../fn/user/get-connected-user';
import { GetConnectedUser$Params } from '../fn/user/get-connected-user';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class UserApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConnectedUser()` */
  static readonly GetConnectedUserPath = '/users/me';

  /**
   * Get the connected user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConnectedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConnectedUser$Response(params?: GetConnectedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    const obs = getConnectedUser(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the connected user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConnectedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConnectedUser(params?: GetConnectedUser$Params, context?: HttpContext): Observable<User> {
    const resp = this.getConnectedUser$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

}
